import { useBlockLibrary, useProducts } from "../../Api/newSockets.api";
import ActionButton from "../Buttons/ActionButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import { StarRating } from "../StarRating/StarRating";
import React, { useState } from "react";
import { ReactComponent as QuickViewIcon } from "../../assets/icons/eye.svg";


import { useHistory } from "react-router-dom";

type Interface = {
  mId: number;
  image?: string;
  title: string;
  description: string;
  author?: string;
  imported?: boolean;
  price?: boolean
  requestQuote?: boolean
};

const MarketplaceCard = (props: Interface) => {
  const history = useHistory();
  const { removeBlockLibrary, importBlockLibrary } = useBlockLibrary();
  const { handleRequestQuote } = useProducts();
  const id = props.mId && props.mId;
  const [loading, setLoading] = useState(false);
  const [quoteRequested, setQuoteRequested ] = useState(false);

  const handleInstall = (blockLibraryId) => {
    setLoading(true);
    importBlockLibrary(blockLibraryId).then(() => setLoading(false));
  };

  const handleRemove = (blockLibraryId) => {
    setLoading(true);
    removeBlockLibrary(blockLibraryId).then(() => setLoading(false));
  };

  const handleQuote = (productId) => {
    setLoading(true)
    handleRequestQuote(productId).then(() => setLoading(false));
    setQuoteRequested(true)
  };
  const handleBlockLibrary = (id) => {
    if (props.imported) {
      handleRemove(id)
    } else {
      handleInstall(id)
    }
  };

//   <div
//   className="marketplace-card-body"
//   onClick={() =>
//     history.push(`/marketplace/block-libraries/${props.mId}`)
//   }
// >
//   <div className="marketplace-card-image-container">
//     <div className="marketplace-card-image">
//       <img src={props.image && props.image} alt="" />
//     </div>
  // </div>
  return (
    <div className="marketplace-card">
      <div className="marketplace-card-image">
        <img src={props.image && props.image} alt="" />
      </div>
      <div className="marketplace-card-body">

        <div className="marketplace-card-content">
          <div className="marketplace-card-title">
            {props.title && props.title}
          </div>
          <div className="marketplace-card-price">
            {!props.price && "Free"}
          </div>
          <div className="marketplace-card-description">
            {props.description && props.description.slice(0, 100) + "..."}
          </div>
          {id !== 1 && props.author && (
            <div className="marketplace-card-author">
              Author: {props.author && props.author}
            </div>
          )}
          {props.price && (
            <div className="marketplace-card-price">
              {props.price && props.price} $
            </div>
          )}
        </div>
      </div>
      <div className="marketplace-card-footer">


        {
          
          !props.requestQuote ? 
          <PrimaryButton loading={loading} onSubmit={() => handleBlockLibrary(id)} className={`marketplace-card-footer-btn ${props.imported && "installed"}`}>
           { props.imported ? "Remove" : "Install" }
          </PrimaryButton>
          :
          <PrimaryButton loading={loading} onSubmit={() => handleQuote(id)} className={`marketplace-card-footer-btn ${quoteRequested && "installed"}`}>
            { !quoteRequested ? "Request a Quote" : "Quote Requested" }
          </PrimaryButton>
        }
        <ActionButton icon={<QuickViewIcon style={{ fill: "#9a9a9a"}}/>} className="marketplace-card-small-btn" />
        
      </div>
    </div>
  );
};

export default MarketplaceCard;
